import CustomSelect from "../../../../../common/interactive/CustomSelect";
import React, { useEffect, useState } from "react";
import { policeReportFunctions } from "../../../../../../lib/policeReport";
import TransferInsurance from "./TransferInsurance";
import PoliceReportVerificationBox from "../PoliceReportVerificationBox";
import AsignCreateInsurance from "./AsignCreateInsurance";


export default function AtFaultInsuranceItem({classes, activeCase, item, index, isProcessed}) {

    const [selectedInsurance, setSelectedInsurance] = useState(null)
    // const [selectedInsuranceID, setSelectedInsuranceID] = useState(null)

    const fields = [
        {
            label: 'Carrier name',
            value: 'carrier_name',
            insurance_field: 'insurance_carrier.name',
            should_copy_over: false
        },
        {
            label: 'Name on policy',
            value: 'name_on_policy',
            insurance_field: 'insured_name',
            is_updateable: true,
            is_editable: true,
            field_type: 'input',
        },
        {
            label: 'Policy Number',
            value: 'policy_number',
            insurance_field: 'policy_number',
            is_updateable: true,
            is_editable: true,
            field_type: 'input',
        },
        {
            label: 'Commercial Policy',
            value: 'is_commercial',
            insurance_field: 'commercial_policy',
            type: 'checkbox',
            is_updateable: true,          
            is_editable: true,
            field_type: 'checkbox',
        },
        {
            label: 'Patient at fault',
            value: 'patient_at_fault',
            insurance_field: 'at_fault',
            type: 'checkbox',
            at_fault_custom_check: true,
            is_updateable: true,           
            is_editable: true,
            field_type: 'radio',
        },
        {
            label: 'Vehicle Make',
            value: 'vehicle.make',
            insurance_field: 'vehicle_make',
            is_updateable: true,
            is_editable: true,
            field_type: 'input',
        },
        {
            label: 'Vehicle Model',
            value: 'vehicle.model',
            insurance_field: 'vehicle_model',
            is_updateable: true,
            is_editable: true,
            field_type: 'input',
        },
        {
            label: 'Vehicle Year',
            value: 'vehicle.year',
            insurance_field: 'vehicle_year',
            is_updateable: true,
            is_editable: true,
            field_type: 'input',
        },
        {
            label: 'Vehicle Damage',
            value: 'vehicle.damage',
            insurance_field: 'vehicle_damage',
            is_updateable: true,
            is_editable: true,
            field_type: 'textarea',
        },
    ]


    const options = activeCase.liabilities && activeCase.liabilities.length ? activeCase.liabilities.map(arrayItem => {
        return {
            label: arrayItem.insurance_carrier?.name,
            value: arrayItem.id,
        }
    }) : [{label: 'No insurance', value: null, manual_selection: false}];


    function changeInsuranceHandler(value) {
        setSelectedInsurance(activeCase.liabilities.find(item => item.id == value.data.value))
        // setSelectedInsuranceID(value.data.value)
    }

    useEffect(() => {
        if (selectedInsurance) {
            setSelectedInsurance(activeCase.liabilities.find(item => item.id == selectedInsurance.id))
        } else {
            if (policeReportFunctions.isMatchInsurance(item, activeCase.liabilities)) {
                setSelectedInsurance(policeReportFunctions.isMatchInsurance(item, activeCase.liabilities))
            }
        }
    }, [activeCase.liabilities])



    return <div className={classes.group}>
        <h3>At Fault Insurance {index > 0 ? `#${index + 1}` : ''}</h3>

        <div className={classes.group_row}>
            <div className={classes.label}>
                
            </div>
            <div className={classes.value}>
                
            </div>
            <div className={classes.status}>            
                
            </div>
            <div className={classes.value}>                
                {activeCase.liabilities && activeCase.liabilities.length > 0 ? <CustomSelect optionsData={options} label={'Insurances'} action={changeInsuranceHandler} preSelectedValue={selectedInsurance?.id} isDisabled={isProcessed}/> : 
                
                !isProcessed && <div>
                    <h4 className={classes.search_title}>There are no insurances on the case. You can search for an insurance, create a new one or transfer an insurance from the police report</h4>
                    
                    <AsignCreateInsurance classes={classes} item={item} folder={'liabilities'} apiCase={'case_liability'}/>
                </div>
                }
            </div>
        </div>

        {fields.map(field => (
            <React.Fragment key={field.value}>
                {field.is_updateable ? <>
                    <PoliceReportVerificationBox isProcessed={isProcessed} at_fault_custom_check={field.at_fault_custom_check} type={field.type} isEditable={field.is_editable && !isProcessed} fieldType={field.field_type} caseId={activeCase.case.id} classes={classes} label={field.label} reportValue={policeReportFunctions.getReportField(item, field.value)} checkForInsurance={true} isInsurance={selectedInsurance ? true : false} eCMValue={selectedInsurance ? policeReportFunctions.getInsuranceField(selectedInsurance, field.insurance_field) : null} identifier={{folder: 'liabilities',type: 'case_liability', field: field.insurance_field, type_id: selectedInsurance ? selectedInsurance.id : null}}/>
                </> : <>
                    <div className={classes.group_row} key={field.value}>
                        <div className={classes.label}>
                            <span>{field.label}</span>
                        </div>
                        <div className={classes.value}>
                            <div className={`${classes.input}`}>{policeReportFunctions.getReportField(item, field.value)}</div>
                        </div>
                        <div className={classes.status}>            
                            
                        </div>
                        <div className={classes.value}>                

                        {/* insurance_carrier.name */}
                        {/* field.insurance_field */}
                            {selectedInsurance && <div className={`${classes.input}`}>{policeReportFunctions.getInsuranceField(selectedInsurance, field.insurance_field)}</div>}
                        </div>
                    </div>
                </>}
            </React.Fragment>
        ))}


        {!isProcessed && <TransferInsurance classes={classes} item={item} folder={'liabilities'} allFields={fields}/>}

        {/* <CustomSelect optionsData={options} label={'Insurances'} />
        
        <PoliceReportBox caseId={activeCase.case.id} classes={classes} label={'Carrier name'} reportValue={item.carrier_name} eCMValue={'medpay_ins_owner'} primaryMedPay={activeCase.mp_pip_um ? activeCase.mp_pip_um[0] : null}/>

        <PoliceReportBox caseId={activeCase.case.id} classes={classes} label={'Name on policy'} reportValue={item.name_on_policy} eCMValue={'medpay_ins_owner'} primaryMedPay={activeCase.mp_pip_um ? activeCase.mp_pip_um[0] : null}/>

        <PoliceReportBox caseId={activeCase.case.id} classes={classes} label={'Policy Number'} reportValue={item.policy_number} eCMValue={'medpay_ins_owner'} primaryMedPay={activeCase.mp_pip_um ? activeCase.mp_pip_um[0] : null}/> */}
    </div>
}